import React from "react";

const Reload = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M7.54 5.893A15.938 15.938 0 0118 2c8.837 0 16 7.163 16 16 0 3.418-1.072 6.586-2.896 9.184L26 18h4.8A12.8 12.8 0 009.136 8.765L7.541 5.893zm20.92 24.214A15.938 15.938 0 0118 34C9.163 34 2 26.837 2 18c0-3.418 1.072-6.586 2.896-9.184L10 18H5.2a12.8 12.8 0 0021.664 9.235l1.595 2.872z"
            fill={fill}
        />
    </svg>
);

export default Reload;